import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import { CapeeshWebState } from '../AppWebGLConstants'
import UnityAppContainer from '../UnityAppContainer/UnityAppContainer'

const useStyles = makeStyles((theme) => ({}))

export const appVersion = '3.1.3'
export const capeeshWebAppVersion = `CapeeshWeb:${appVersion}`

const appBuildName = 'CapeeshWeb_Build_0.0.10'

const CapeeshWebView = ({ student, previewHeight, previewWidth, showBorder, urlLocation }) => {
    const classes = useStyles()

    const emptyGuid = '00000000-0000-0000-0000-000000000000'
    const AllSettings = [
        'Email',
        'UserName',
        'Password',
        'Language',
        'Music',
        'Sounds',
        'Vibration',
        'AudioAll',
        'Feedback',
        'PushNotification',
        'PrivacyPolicy',
        'GeneralAll',
        'TestingMode',
        'SignOut',
        'AppVersion',
    ]

    const SettingsFilter = { SettingsToFilter: ['Language', 'Vibration', 'PushNotification', 'SignOut'] }

    const CheckForUrlParams = () => {
        const urlParams = new URLSearchParams(window.location.search)

        console.log(urlParams)

        return {
            CourseGroupId: urlParams.get('coursegroup') ? urlParams.get('coursegroup') : emptyGuid,
            TopicId: urlParams.get('topic') ? urlParams.get('topic') : '',
            CustomLessonId: urlParams.get('lesson') ? urlParams.get('lesson') : emptyGuid,
            L1Id: student?.userDashboardLanguageId ? student?.userDashboardLanguageId : '',
        }
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
            }}>
            <UnityAppContainer
                buildName={appBuildName}
                basePath={'/build/unityFull/'}
                version={appVersion}
                previewHeight={previewHeight}
                previewWidth={previewWidth}
                useBorder={showBorder}
                webType={CapeeshWebState.CapeeshWebStudent}
                dashboardLanguage={student?.userDashboardLanguageId}
                urlReloadCheck={CheckForUrlParams}
                settingsFilter={SettingsFilter}
                shouldShowBetaTag={true}
                urlLocation={urlLocation}
            />
        </div>
    )
}

CapeeshWebView.propTypes = {}

const mapStateToProps = (state) => {
    return { student: state.student }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(CapeeshWebView)
